import type { InterventionLite } from "@/entities/intervention";
import type { UsersSelectOptionItem } from "@/modules/users/users-select";

import { useInterventionsBatchUpdate } from "@/entities/interventions";
import { useBatchEditForm } from "@/modules/batch-edit-form";
import { getUsersSelectOptionItem } from "@/modules/users/users-select";

const fieldName = "users";

export const useInterventionsBatchEditUsers = (
  interventions: InterventionLite[]
) => {
  const initialValue = (interventions[0]?.[fieldName] ?? []).map(
    getUsersSelectOptionItem
  );

  const { mutate, isPending, status, error } =
    useInterventionsBatchUpdate(interventions);

  const onMutateReady = (users: UsersSelectOptionItem[]) => {
    const ids = users.map((user) => user.value);
    mutate({ [fieldName]: ids });
  };

  const formProps = useBatchEditForm({
    fieldName,
    initialValue,
    onMutateReady,
    status,
    error,
  });

  return {
    ...formProps,
    fieldName,
    initialValue,
    isPending,
  };
};
